import { render, staticRenderFns } from "./TestimonialPage.vue?vue&type=template&id=cfc725ec&"
import script from "./TestimonialPage.vue?vue&type=script&lang=js&"
export * from "./TestimonialPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports